<template>
	<div>
		<a-modal v-show='!ishand' id='sup_con' width='40rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			:dialog-style="{ top: (28 - (form.qmisAdministrativeContractLogList.length*3.5>7?7:form.qmisAdministrativeContractLogList.length*3.5))+'vh'  }"
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div v-html='items?"編&nbsp;&nbsp;&nbsp;&nbsp;輯":"添&nbsp;&nbsp;&nbsp;&nbsp;加"'
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;font-size: 0.9rem;">
					
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;left: -.5rem;">
					<a-form-model ref='form' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item label='合約號碼' prop="contract_number">
									<a-input onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')" v-model="form.contract_number" class='warp_width' />
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='聯絡名稱' prop='name'>
									<a-input v-model="form.name" class='warp_width' @input='getdata' />
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item label='電話號碼' prop='phone'>
									<a-input v-model="form.phone" class='warp_width' @input='form.phone=isNaN(form.phone)?"":form.phone' />
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='電子郵箱' prop='email'>
									<a-input v-model="form.email" class='warp_width' @input='emailfn' />
								</a-form-model-item>
							</a-col>
							<!-- <a-col :span='12'>
								<a-form-model-item label='公司名稱' prop='contract_name'>
									<a-input v-model="form.contract_name" class='warp_width' @input='getdata' />
								</a-form-model-item>
							</a-col> -->
						</a-row>
						<a-row>
							<a-col :span='12'>
								<a-form-model-item label='開始日期' prop='begindate'>
									<a-date-picker
									v-model='form.begindate'  placeholder='' :disabled-date="disabledDate"/>
								</a-form-model-item>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='完結日期' prop='enddate' id='mamabubu'>
									<a-date-picker
									v-model='form.enddate1' @change='gettime' placeholder='' :disabled-date="disabledDates" />						 
									<a-input v-model='form.enddate' id='mamabubu1' ></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
						<!-- <a-row>
							<a-col :span='24'> -->
						<div id='lastname'>
							<a-form-model-item  prop='contract_name'>
								<div slot='label' v-html='"公司名稱"'
								style="display: inline-block;color: #000000;"></div>
								<el-input v-model="form.contract_name" class='numrule' @input='getdata' />
							</a-form-model-item>
						</div>
						<div id='lastname'>
							<a-form-model-item prop='service_type'>
								<div slot='label' v-html='"合約內容"'
								style="display: inline-block;color: #000000;"></div>
								<!-- <a-input v-model='form.service_type' show-word-limit :maxlength="50"></a-input> -->
								<el-input class="numrule" v-model="form.service_type"  :maxlength="50" />
								<!-- <a-textarea v-model="form.remark" placeholder=" " :auto-size="{ minRows: 3, maxRows: 5 }"
									style='width: 30.5rem;' /> -->
								<!-- <Situationall v-model="form.service_type" :url='$api.getparas' ref='seachope'
									:params='{"type":"service_type"}' 
									:placeholder="''"
									:nameVlaue="'hynr'"
									style="width:100%"
									:valstr='form.service_type1'
									@blur="abc"
									>
								</Situationall> -->
							</a-form-model-item>
						</div>
							<!-- </a-col>
						</a-row> -->
						<!-- <div id='lastname'>
							<a-form-model-item prop='remark'>
								<div slot='label' v-html='"備&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;註"'
								 style="display: inline-block;color: #000000;"></div>
								<a-textarea v-model="form.remark" placeholder=" " :auto-size="{ minRows: 3, maxRows: 5 }"
									style='width: 30.5rem;' />
							</a-form-model-item>
						</div> -->
					
					</a-form-model>
					<a-row v-if='form.qmisAdministrativeContractLogList.length'>
						<div class='mydivs'>
							<div v-for='(item,ind) in form.qmisAdministrativeContractLogList'>
								<div class='f'>
									<div style="position: absolute;top: 0;right: 0;">{{item.createtime}}</div>
								</div>
								<div class='c' v-if='item.contract_number'>合約號碼 : {{item.contract_number}}</div>
								<div class='c' v-if='item.name'>聯絡名稱 : {{item.name}}</div>
								<div class='c' v-if='item.phone'>電話號碼 : {{item.phone}}</div>
								<div class='c' v-if='item.email'>電子郵箱 : {{item.email}}</div>
								<div class='c' v-if='item.contract_name'>公司名稱 : {{item.contract_name}}</div>
								<div class='c' v-if='item.begindate'>開始日期 : {{item.begindate}}</div>
								<div class='c' v-if='item.enddate'>完結日期 : {{item.enddate}}</div>
								<div class='c' v-if='item.service_type'>合約內容 : {{item.service_type}}</div>
								<div class='c' v-if='item.remark'>
									<div v-html='"備&emsp;註&nbsp;:"' style="display: inline-block;"></div>
									{{item.remark}}</div>
								<div class='t' v-if='ind !== form.qmisAdministrativeContractLogList.length-1'></div>
							</div>
						</div>
					</a-row>
					
					<div style="text-align: center;">
						<button class='btn1 btnx' @click='handbect("form")' 
						v-html='"保&emsp;存"'>保存</button>
						<!-- <button class='btn1 btn2' @click='resetForm("form")'>清除</button> -->
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				domainlist:[
					{value:'軟件系統',text:'軟件系統'},
					{value:'硬件系統',text:'硬件系統'},
				],
				ishand: false,
				fourthqty: '',
				labelCol: {
					span: 8
				},
				wrapperCol: {
					span: 16
				},
				visible: true,
				rules: {
					name:[{required:true,message:' ',trigger:'blur'}],
					phone:[{required:true,message:' ',trigger:'blur'}],
					email:[{required:true,message:' ',trigger:'blur'}],
					contract_name:[{required:true,message:' ',trigger:'blur'}],
					enddate:[{required:true,message:' ',trigger:'change'}],
					contract_number:[{required:true,message:' ',trigger:'change'}],
					begindate:[{required:true,message:' ',trigger:'change'}],
				},
				form: {
					 "name":"",
					 "phone":"",
					 "email":"",
					 "begindate":"",
					 "enddate":"",
					 "contract_name":"",
					 "remark":"",
					 "service_type":"",
					 enddate1:'',
					 contract_number:'',
					 qmisAdministrativeContractLogList:[]
				},
			}
		},
		watch:{
			items:{
				deep:true,
				handler(ev){
					
				}
			},
		},
		mounted() {
			console.log(this.items)
			if(this.items){
				this.handz()
			}
		},
		methods: {
			gettime(){
				if(this.form.enddate1){
					this.form.enddate = this.form.enddate1._d ? App.oDate.secsTime3(this.form.enddate1._d) : this.form.enddate1
				}else{
					this.form.enddate = ''
				}
			},
			emailfn() {
				if (this.form.email) {
					// var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
					// if (!(t.test(this.form.email))) {
					// 	this.form.email = ''
					// 	this.$message.warning('請輸入正確的電郵地址')
					// }
				}
			},
			disabledDate(current) {
				if(this.form.enddate){
					return current && current > new Date(this.form.enddate)
				}else{
					return false
				}
			},
			disabledDates(current){
				if(this.form.begindate){
					return current && current < new Date(this.form.begindate)
				}else{
					return false
				}
			},
			getdata() {

			},
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getitem,
					data: {
						"flag":"systemservice",
						 "contraxtid":this.items
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						this.form.service_type1 = JSON.parse(JSON.stringify(this.form.service_type))
						// this.form.enddate = res.data.enddate.split('/').reverse().join('-')
						// this.form.begindate = res.data.begindate.split('/').reverse().join('-')
						this.form.enddate = res.data.enddate.split('/').join('-')
						this.form.begindate = res.data.begindate.split('/').join('-')
						this.form.enddate1 = ''
						console.log(this.form)
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				this.form.contraxtid  = this.items||''
				 this.$refs[ruleForm].validate(valid => {
				        if (valid) {
							this.form.enddate = this.form.enddate._d ? App.oDate.secsTime3(this.form.enddate._d) : this.form.enddate;
							this.form.begindate = this.form.begindate._d ? App.oDate.secsTime3(this.form.begindate._d) : this.form.begindate;
							this.form.token = this.$store.state.token;
							this.form.flag = "systemservice";
							this.$ajax({
								method: 'post',
								url: this.$api.newQmis,
								data: this.form
							}).then(res => {
								if (res.data.qmiscode === 1000) {
									App.oTool.successT();
									this.$emit('child', 1)
								} else {
									App.oTool.warningT(res.data.qmismsg);
								}
							})
				        } else {
				          console.log('error submit!!');
				          return false;
				        }
				      });
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			},
			abc(){
				console.log("12aeq214");
			}
		}
	}
</script>
<style scoped>
	::v-deep  .ant-select-search__field__wrap{
		width: 99%;
	}
	::v-deep .numrule input{
		height: 1.75rem;
		width: 99%;
		font-size: 0.75rem;
		color: #000000;
	}
	::v-deep .numrule .el-input__inner:focus{
		height: 1.75rem;
		line-height: 1.75rem;
		border-color: #0c8b97;
	}
</style>

<style lang="scss">
	#mamabubu{
		position: relative;
	}
	#mamabubu1{
		position:absolute;
		top: -0.4rem;
	    left: 0;
	}
	#sup_con .ant-modal-header,
	#sup_con .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.mark-file1 {
		position: absolute;
		top: 0;
		left: 0;
		width: 19rem;

		div {
			font-size: 1rem;
			padding: .5rem 1rem;
			background-color: #0c8b97;
			border-radius: 10px 10px 0 0;
			color: #fff;
			text-align: center;
		}
	}
	.gsmc .ant-form-item-label {
		width: 15% !important;
	}

	#sup_con {
		.ant-form-explain{
			display: none;
		}
		.ant-modal {
			top: 25vh;
		}

		.ant-col-12 {
			text-align: right;
		}

		.ant-form-item-label {
			width: 30%;
		}
		.ant-form-item, .ant-form-item-control{
			width: 100%;
			.ant-calendar-picker{
				width: 100%;
			}
			
		}
		
		.ant-form-item-control-wrapper{
			width:70%;
			.ant-form-item-control{
				width: 100%;
			}
		}
		#lastname>div{
			// justify-content: flex-end;
			text-align: right;
			}
		#lastname{
			.ant-form-item-label{
				width: 10%;
			}
			.ant-form-item-control-wrapper{
				width: 86%;
				    // left: .3rem;
				    position: relative;
			}
		}
		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.warp-right {
			text-align: right;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .75rem !important;
		}

		.ant-input {
			font-size: .75rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .75rem !important;
		}

		.ant-form-item-children {
			font-size: .75rem !important;
		}

		.mydivs {
			max-height: 11rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;
		
			.c {
				font-size: .75rem;
				margin: .2rem 0;
			}
		
			.f {
				// display: flex;
				// justify-content: space-between;
				position: relative;
				right: 0;
				top: 0;
			}
		
			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
